import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import moment from 'moment'
import axios from 'axios'
import Vuelidate from 'vuelidate'
import { validationMessage } from 'vuelidate-messages'
import Paginate from 'vuejs-paginate'
import './assets/styles/custom.scss';
import VueSwal from 'vue-swal';

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueSwal);
Vue.use(Vuelidate);
Vue.use(validationMessage);
Vue.component('paginate', Paginate)


let baseUrl="https://telecalling.staging.property-pistol.in/api/mobile_crm/";
if(process.env.NODE_ENV === 'production'){
  baseUrl = "https://telecalling.propertypistol.in/api/mobile_crm/"
}
axios.defaults.baseURL = baseUrl;
//axios interceptors
axios.interceptors.request.use(function(config) {
  if (config.url.includes("make_call")) { 
    store.dispatch('setLoading', false);
  }else{
    store.dispatch('setLoading', true);
  }
  if(config.url.indexOf('login') < 0){
    let token = localStorage.getItem('vt-token')
    if(token){
      config.headers.Authorization = `Token token=${token}`
    }else{
      return {
        headers: {},
        method: config.method,
        url: ""
      };
    }
  }
  config.headers['Content-Type'] = 'application/json'
  config.headers['Accept'] = 'application/json'
  config.headers['ngrok-skip-browser-warning'] = 'true'
  return config;
}, function(err) {
  store.dispatch('setLoading', false);
  return Promise.reject(err);
});

axios.interceptors.response.use(function(response) {
  store.dispatch('setLoading', false);
  return response;
}, function(error){
  if(error.response.status === 401){
    localStorage.removeItem('vt-token');
    swal({
      title: "Session Expired",
      text: "You have been redirected to the login page",
      icon: "error"
    })
    .then(router.replace('/login'));
  }else{
    store.dispatch('setLoading', false);
    return Promise.reject(error);
  }
});

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('vt-token')
  if(token && to.name === 'Login'){
    next({name: 'Home'});
  }else if(to.name !== 'Login' && !token){
    next({name: 'Login'});
  }else{
    if(to.name === 'Login'){
      store.dispatch('setLayout', 'login');
    }else{
      store.dispatch('setLayout', 'default');
    }
    next();
  }
})
Vue.filter('asINR', function(value){
  if(!value) return '0'
  return value.toLocaleString('en-IN')
})
Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
